import type TomSelect from "tom-select";
import {
    selectAllItemsEndedEventName,
    selectAllItemsStartedEventName,
} from "./SelectedAutoItemsTomSelectPlugin";

export function selectAllButtonTomSelectPlugin(this: TomSelect, options: {[textContent: string]: string}): void {
    this.on("initialize", () => {
        let buttonsWrapper = this.dropdown.querySelector(".tomselect-dropdown-buttons-wrapper");
        const dropdownInputWrap = this.dropdown.querySelector(".dropdown-input-wrap");

        const selectAllButton = document.createElement("button");
        selectAllButton.type = "button";
        selectAllButton.className = "actions-btn btn btn-light";
        selectAllButton.textContent = options?.textContent ?? "Select All";

        const startSelectAllEvent: CustomEvent = new CustomEvent(selectAllItemsStartedEventName);
        const endSelectAllEvent: CustomEvent = new CustomEvent(selectAllItemsEndedEventName);
        selectAllButton.addEventListener("click", (e) => {
            this.control.dispatchEvent(startSelectAllEvent);
            const allOptions = this.dropdown.querySelectorAll("[role=\"option\"]:not(.disabled)");

            allOptions.forEach((option: Element) => {
                const htmlOption = option as HTMLElement;
                if (!this.items.includes(htmlOption.dataset.value ?? "")) {
                    this.addItem(htmlOption.dataset.value ?? "");
                }
            });
            this.control.dispatchEvent(endSelectAllEvent);
        });

        if (!buttonsWrapper) {
            buttonsWrapper = document.createElement("div");
            buttonsWrapper.className = "tomselect-dropdown-buttons-wrapper";
            buttonsWrapper.appendChild(selectAllButton);

            if (dropdownInputWrap) {
                dropdownInputWrap.insertAdjacentElement("afterend", buttonsWrapper);
            } else {
                this.dropdown.insertBefore(buttonsWrapper, this.dropdown.firstChild);
            }
        } else {
            buttonsWrapper.appendChild(selectAllButton);
        }
    });
}
